/**
 * `/settings/activity-types` — the scheduling service's vocabulary.
 *
 * It had no screen until now, which is what made an unseeded deployment's
 * calendar unusable: «نوع فعالیت» is required, the list was empty, and nothing
 * in the app could add to it.
 */
import { useMutation, useQuery } from '@apollo/client';
import React, { useMemo, useState } from 'react';
import { VocabularyScreen } from '../../components/settings/VocabularyScreen.web.jsx';
import {
  ACTIVITY_TYPES_QUERY,
  CREATE_ACTIVITY_TYPE,
  SET_ACTIVITY_TYPE_ACTIVE,
  UPDATE_ACTIVITY_TYPE,
} from '../../lib/queries.js';
import { S } from '../../lib/strings.js';

export function ActivityTypesScreen() {
  const [includeInactive, setIncludeInactive] = useState(true);
  const variables = { includeInactive };
  const { data, loading } = useQuery(ACTIVITY_TYPES_QUERY, { variables });
  const refetchQueries = [{ query: ACTIVITY_TYPES_QUERY, variables }];

  const [create, createState] = useMutation(CREATE_ACTIVITY_TYPE, { refetchQueries });
  const [update, updateState] = useMutation(UPDATE_ACTIVITY_TYPE, { refetchQueries });
  const [setActive, activeState] = useMutation(SET_ACTIVITY_TYPE_ACTIVE, { refetchQueries });

  const rows = useMemo(
    () => [...(data?.activityTypes ?? [])].sort((a, b) => a.sortOrder - b.sortOrder),
    [data],
  );

  return (
    <VocabularyScreen
      title={S.settings.sections.activityTypes}
      hint={S.settings.activityTypes.hint}
      emptyHint={S.settings.activityTypes.empty}
      createTitle={S.settings.activityTypes.createTitle}
      codePrefix="ACTIVITY"
      rows={rows}
      loading={loading}
      busy={createState.loading || updateState.loading}
      error={createState.error || updateState.error || activeState.error}
      includeInactive={includeInactive}
      onIncludeInactiveChange={setIncludeInactive}
      onCreate={(input) => create({ variables: { input } })}
      onUpdate={(row, input) => update({ variables: { id: row.id, input } })}
      onSetActive={(row, isActive) => setActive({ variables: { id: row.id, isActive } })}
    />
  );
}
